// ** Modules
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

// ** UI
import Box from '@mui/material/Box';

// ** Components
import Section from '@/components/common/Section';

// ** Types
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksWysiwygBlock as WysiwygBlockProps } from '@/types/graphql';

type ComponentBlocksWysiwygBlockProps = StrapiComponentProps<WysiwygBlockProps>;

const ComponentBlocksWysiwygBlock = ({ containerSx, editorContent }: ComponentBlocksWysiwygBlockProps) => {
	// Sanitize the HTML
	const cleanHtml = DOMPurify.sanitize(editorContent || '', {
		USE_PROFILES: { html: true } // optional, use safe HTML profile
	});

	return (
		<Section containerSx={containerSx}>
			<Box
				sx={{
					'& *': { maxWidth: '100%', boxSizing: 'border-box' },
					'& figure': {
						margin: 0,
						padding: 0,
						display: 'block',
						maxWidth: '100%',
						overflow: 'hidden',
						'& img': { display: 'block', maxWidth: '100%', height: 'auto' }
					},
					'& iframe': { maxWidth: '100%', width: '100%' }
				}}
			>
				{parse(cleanHtml)}
			</Box>
		</Section>
	);
};

export default ComponentBlocksWysiwygBlock;
